import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  CHANNEL_SETTING_FAILURE,
  CHANNEL_SETTING_FIND_ALL,
  CHANNEL_SETTING_FIND_ALL_SUCCESS,
  CHANNEL_SETTING_FIND_SUCCESS,
  CHANNEL_SETTING_UPDATE_LOADING,
  CORE_UPDATE_LOADING,
} from '@store/actions';
import { ConfiguracionCanalService } from '@core/services/channel-setting/channel-setting.service';
import { selectLocalChannelId } from '@store/selectors';

@Injectable()
export class ConfiguracionCanalEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private ConfiguracionCanalService: ConfiguracionCanalService
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CHANNEL_SETTING_FIND_ALL),
      withLatestFrom(
        this.store.select(selectLocalChannelId),
      ),
      filter(([_,localChannelId])=>!!localChannelId),
      map(([_, localChannelId]) => {
        return { localChannelId: localChannelId as string };
      }),
      mergeMap(({ localChannelId }) => {
        this.store.dispatch(CHANNEL_SETTING_UPDATE_LOADING({  loading: true }));
        return this.ConfiguracionCanalService.findAll(localChannelId).pipe(
          mergeMap(({ data }) => {
            const [ConfiguracionCanal] = data ;

            return [
              CHANNEL_SETTING_FIND_SUCCESS({ ConfiguracionCanal: ConfiguracionCanal }),
              CHANNEL_SETTING_FIND_ALL_SUCCESS({ ConfiguracionCanalList: [ConfiguracionCanal] }),
              CHANNEL_SETTING_UPDATE_LOADING({ loading: false }),
              CORE_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => {
            this.store.dispatch(CHANNEL_SETTING_UPDATE_LOADING({ loading: false }))
            return of(CHANNEL_SETTING_FAILURE({ error }))
          })
        )
      }),
    )
  );

}
